/**
 * Library with constants and utitlity functions based on screen realestate
 * @author Moeed Ahmad <moeeed@250mils.com>
 */

export enum ScreenBreakpoints {
  XS = '480',
  SMALL = '576',
  MEDIUM = '768',
  TABLET = '896',
  LARGE = '992',
  LAPTOP = '1366',
  XL = '1400',
  MOBILE_MODAL_ACTIVATION_BREAKPONT = '550',
  HOMEPAGE_MOBILE_BREAKPOINT = '950',
  AI_CHAT_SMALL_BREAKPOINT = '1110',
  BG_REMOVER_UPSELL_BREAKPOINT = '850',
}
